import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  RemoveIdpDomainMutation,
  RemoveIdpDomainMutationVariables,
} from '@investigator/shared/generated/graphql';

export const REMOVE_IDP_DOMAIN = gql`
  mutation removeIdpDomain($idp_domain: String!) {
    removeIdpDomain(idp_domain: $idp_domain) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useRemoveIdpDomain = (
  options?: MutationHookOptions<
    RemoveIdpDomainMutation,
    RemoveIdpDomainMutationVariables
  >,
) => {
  return useMutation<RemoveIdpDomainMutation, RemoveIdpDomainMutationVariables>(
    REMOVE_IDP_DOMAIN,
    options,
  );
};
